import React from 'react';
import { Document, Page } from 'react-pdf';

const PdfPreview = ({ fileUrl }) => {
    console.log("fileUrl",fileUrl)
  return (
    <div>
      <Document file={fileUrl}>
        <Page pageNumber={1} />
      </Document>
    </div>
  );
};

export default PdfPreview;